module.exports = __webpack_public_path__ + "static/img/no-server.9e7e3837.png";